import { useEffect } from 'react';

import { useStore } from '@/store/useStore';
import { useShallow } from 'zustand/react/shallow';

const formatDocumentTitleGameName = (value?: string) =>
  value && value.length > 0 ? value.toUpperCase() : 'FANDUEL GAME WINDOW';

const GameWindowDocumentTitle = () => {
  const gameName = useStore((s) => s.gameContext.gameName);
  const { currentTime, sessionTime, gameTime } = useStore(
    useShallow((s) => ({
      currentTime: s.currentTime,
      sessionTime: s.sessionTime,
      gameTime: s.gameTime,
    })),
  );

  useEffect(() => {
    document.title = `${formatDocumentTitleGameName(gameName ?? 'FanDuel GAME WINDOW ')} - Session Time: ${sessionTime} | Game Time: ${gameTime} | Current Time: ${currentTime}`;
  }, [currentTime, gameName, gameTime, sessionTime]);

  return null;
};

export default GameWindowDocumentTitle;
